export let editorAccess = 'none'

export function setEditorAccess(access: string) {
  editorAccess = access
}
